/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, ReactNode } from "react";

interface ReadOnlyContextType {
  isDeactivated: boolean;
  isReadOnly: boolean;
  accountType: 'portal' | 'partner';
}

const ReadOnlyContext = createContext<ReadOnlyContextType | undefined>(undefined);

export const useReadOnly = () => {
  const context = useContext(ReadOnlyContext);
  if (context === undefined) {
    // Return a safe default when used outside provider (e.g., in non-portal/partner pages)
    return {
      isDeactivated: false,
      isReadOnly: false,
      accountType: 'portal' as const,
    };
  }
  return context;
};

interface ReadOnlyProviderProps {
  children: ReactNode;
  isDeactivated: boolean;
  accountType: 'portal' | 'partner';
}

export const ReadOnlyProvider = ({ children, isDeactivated, accountType }: ReadOnlyProviderProps) => {
  return (
    <ReadOnlyContext.Provider
      value={{
        isDeactivated,
        isReadOnly: isDeactivated,
        accountType,
      }}
    >
      {children}
    </ReadOnlyContext.Provider>
  );
};
